import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/LockOpen.es.js";
const e = o.forwardRef((c, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...c, weights: n }));
e.displayName = "LockOpenIcon";
const p = e;
export {
  p as LockOpen,
  e as LockOpenIcon
};
